export enum LEADERBOARD {
    /**
     * @value Average score: %AVERAGE_SCORE%%
     */
    AVERAGE_SCORE = 'LEARNING.AVERAGE_SCORE',
    /**
     * @value Current
     */
    CURRENT = 'LEARNING.CURRENT',
    /**
     * @value Full Ranking
     */
    FULL_RANKING = 'LEARNING.FULL_RANKING',
    /**
     * @value Leaderboard
     */
    LEADERBOARD_TITLE = 'WIDGET_TYPE_LEARNING-LEADERBOARD',
    /**
     * @value Pick
     */
    PICK = 'LEARNING.PICK',
    /**
     * @value {"one":"%NUMBER% point","other":"%NUMBER% points"}
     */
    POINT = 'LEADERBOARD.POINT',
    /**
     * @value Your ranking position
     */
    USER_RANKING = 'LEARNING.USER_RANKING',
}
